import { defineSearchEngine as defineBaseSearchEngine, } from '@coveo/headless/ssr';
// Workaround to prevent Next.js erroring about importing CSR only hooks
import React from 'react';
import { singleton } from '../utils.js';
import { buildControllerHooks, buildEngineHook, buildHydratedStateProvider, buildStaticStateProvider, } from './common.js';
// Wrapper to workaround the limitation that `createContext()` cannot be called directly during SSR in next.js
export function createSingletonContext() {
    return singleton(() => React.createContext(null));
}
/**
 * Returns controller hooks as well as SSR and CSR context providers that can be used to interact with a search engine
 *  on the server and client side respectively.
 */
export function defineSearchEngine(options) {
    const singletonContext = createSingletonContext();
    return {
        ...defineBaseSearchEngine({ ...options }),
        useEngine: buildEngineHook(singletonContext),
        controllers: buildControllerHooks(singletonContext, options.controllers),
        StaticStateProvider: buildStaticStateProvider(singletonContext),
        HydratedStateProvider: buildHydratedStateProvider(singletonContext),
    };
}
//# sourceMappingURL=search-engine.js.map